import {ApplicationProduct} from "../types.ts";
import {
    Stack,
    Text
} from "@mantine/core";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {DataTableColumn} from "mantine-datatable";
import {NavLink} from 'react-router-dom';


export const useApplicationProductsTableColumns = (applicationId: string) => {

    if (!applicationId) {
        throw new Error('applicationId is required parameter')
    }

    const columns: DataTableColumn<ApplicationProduct>[] = [
        {
            accessor: 'productId',
            title: 'Product',
            ellipsis: true,
            render: (item) => {
                return (
                    <Stack>
                        {item.product ? <NavLink
                                to={`/applications/${item.applicationId}/products/${item.id}`}><Text
                                fw={700}
                                fs={'sm'}>{item.product.name}</Text></NavLink> :
                            <NavLink
                                to={`/applications/${item.applicationId}/products/${item.id}`}><Text
                                fs={'sm'}
                                fw={700}>{item.productId}</Text></NavLink>}
                    </Stack>
                )

            },

        },
        {
            accessor: 'applicationProductStatus',
            title: 'Status'
        },
        {
            accessor: 'position',
            title: 'Position'
        },
        {
            accessor: 'created',
            title: 'Created',
            render: (item) => formatTimestamp(item.created, 'MMM DD, YYYY'),
        }
    ];


    return {
        columns,
    };
};
